module.exports = __webpack_public_path__ + "img/number-black-14.e34dabda.png";